/**
 * utils
 *
 * @author Shigq
 * @date 2021/11/8 17:32
 */
var _dateUtils = require('./lib/date-utils')
var _cookieUtils = require('./lib/cookie-utils')
var _currencyUtils = require('./lib/currency-utils')
var _downloadUtils = require('./lib/download')
var _commonUtils = require('./lib/common-utils')
var _encryptUtils = require('./lib/encrypt-utils')
var _urlUtils = require('./lib/url-utils')

var _validator = require('./lib/validator')
var _filter = require('./lib/filter')
var _http = require('./lib/http')
var _mock = require('./lib/mock')
var _vab = require('./lib/vab')

var utils = {
	dataUtils: _dateUtils,
	cookieUtils: _cookieUtils,
	currencyUtils: _currencyUtils,
	downloadUtils: _downloadUtils,
	commonUtils: _commonUtils,
	encryptUtils: _encryptUtils,
	urlUtils: _urlUtils,
	validator: _validator,
	filter: _filter,
	http: _http,
	mock: _mock,
	vab: _vab,
}

console.log('utils init')

module.exports = utils
